const Session = (() => {

  const load = function (path, key) {
    return localStorage.getItem(`${path}_${key}`);
  };

  const save = function (path, key, value) {
    key = `${path}_${key}`;
    if (value) {
      localStorage.setItem(key, value);
    }
    else {
      localStorage.removeItem(key);
    }
  };

  return {
    save: save,
    load: load
  }

})();

export default Session;
